export const EnhancedReturnsStoreStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  AuthenticationInitiated: 'AuthenticationInitiated',
  Authenticated: 'Authenticated',
  Blocked: 'Blocked',
  DeactivationRequested: 'DeactivationRequested',
  Inactive: 'Inactive',
  DefaultCarrierSelected: 'DefaultCarrierSelected',
  DefaultReturnLocationSelected: 'DefaultReturnLocationSelected',
};
